module.exports = __webpack_public_path__ + "img/sdg_main.a379f14e.jpeg";